import { httpApi } from '@app/api/http.api';
import {
  LoginDto,
  RegisterDto,
  ForgotPasswordDto,
  ResetPasswordDto,
  LoginResponseDto,
  RegisterResponseDto,
} from '@app/types/api.types';

// Remove mock import for production
// import './mocks/auth.api.mock';

export const login = (loginPayload: LoginDto): Promise<LoginResponseDto> =>
  httpApi.post<LoginResponseDto>('/auth/login', loginPayload).then(({ data }) => data);

export const register = (registerData: RegisterDto): Promise<RegisterResponseDto> =>
  httpApi.post<RegisterResponseDto>('/auth/register', registerData).then(({ data }) => data);

export const forgotPassword = (forgotPasswordPayload: ForgotPasswordDto): Promise<void> =>
  httpApi.post<void>('/auth/forgot-password', forgotPasswordPayload).then(() => undefined);

export const resetPassword = (resetPasswordPayload: ResetPasswordDto): Promise<void> =>
  httpApi.post<void>('/auth/reset-password', resetPasswordPayload).then(() => undefined);
